
import { useTranslation } from 'react-i18next';

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className={` inset-0 top-[150px] max-w-7xl mt-20`}>
      <>

        <h1 className="text-[#2a7a2a] text-center text-4xl">Terms of Service</h1>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            AGREEMENT TO TERMS
            <br />
          </strong>
        </h2>{" "}
        <br /> <p>
          <small>Last updated: 08.12.2022</small>
        </p>
        <br /> <p>
          These Terms of Service constitute a legally binding agreement made between
          you, whether personally or on behalf of an entity (“you”) and
          SerhiiShevchenko.com (“Company”, “we”, “us” or “our”), concerning your
          access to and use of Our Products, Services, Website as well as any other
          media channel, linked, or otherwise connected thereto (collectively, the
          “Site”).
        </p>
        <br /> <p>
          You agree that by accessing the Site, you have read, understood, and agree
          to be bound by all of these Terms of Service. If you do not agree with all
          of these Terms of Service, then you are expressly prohibited from using the
          Site and you must discontinue use immediately.
        </p>
        <br /> <p>
          Supplemental Terms of Service or documents that may be posted on the Site
          from time to time are hereby expressly incorporated herein by reference. We
          reserve the right, in our sole discretion, to make changes or modifications
          to these Terms of Service at any time and for any reason.
        </p>
        <br /> <p>
          We will alert you about any changes by updating the “Last updated” date of
          these Terms of Service, and you waive any right to receive specific notice
          of each such change. However, we may alert you about some important changes
          of these Terms of Service via email or other method of communication.
        </p>
        <br /> <p>
          It is your responsibility to periodically review these Terms of Service to
          stay informed of updates. You will be subject to, and will be deemed to have
          been made aware of and to have accepted, the changes in any revised Terms of
          Service by your continued use of the Site after the date such revised Terms
          of Service are posted.
        </p>
        <br /> <p>
          The Site is intended for users who are at least 18 years old. Persons under
          the age of 18 are not permitted to register for the Site. Any registration
          by, use of or access to any of our Products, Services or other Content by
          anyone under age 18 is unauthorized, unlicensed and in violation of these
          Terms of Service. By accessing or using our Products, Services or other
          Content, you represent and warrant that you are at least 18 years old.
        </p>
        <br /> <p>
          These Terms of Service require the use of arbitration on an individual basis
          to resolve disputes, rather than jury trials, and limit the remedies
          available to you in the event of a dispute. You fully understand and agree
          that by enrolling in, purchasing and/or using any of our Products, Services
          and other materials that you are waiving certain legal rights and you are
          voluntarily agreeing to do so.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            INTELLECTUAL PROPERTY RIGHTS
            <br />
          </strong>
        </h2>
        Unless otherwise indicated, the Site is our proprietary property and all
        source code, databases, functionality, software, website designs, audio,
        video, text, photographs, graphics and any other content on the Site
        (collectively, the “Content”) and the trademarks, service marks, and logos
        contained therein (the “Marks”) are owned or controlled by us or licensed to
        us, and are protected by copyright and trademark laws and various other
        intellectual property rights.
        <p />
        <br /> <p>
          The Content and the Marks are provided on the Site “AS IS” for your
          information and personal use only. Except as expressly provided in these
          Terms of Service, no part of the Site and no Content or Marks may be copied,
          reproduced, aggregated, republished, uploaded, posted, publicly displayed,
          encoded, translated, transmitted, distributed, sold, licensed, or otherwise
          exploited for any commercial purpose whatsoever, without our express prior
          written permission.
        </p>
        <br /> <p>
          Provided that you are eligible to use the Site, you are granted a limited
          license to access and use the Site and to download or print a copy of any
          portion of the Content to which you have properly gained access solely for
          your personal, non-commercial use. We reserve all rights not expressly
          granted to you in and to the Site, the Content and the Marks.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            USER REPRESENTATIONS
            <br />
          </strong>
        </h2>
        By using the Site, you represent and warrant that:
        <br />
        (1) all registration information you submit will be true, accurate, current,
        and complete;
        <br />
        (2) you will maintain the accuracy of such information and promptly update
        such registration information as necessary;
        <br />
        (3) you have the legal capacity and you agree to comply with these Terms of
        Service;
        <br />
        (4) you are not under the age of 18;
        <br />
        (5) you will not access the Site through automated or non-human means, whether
        through a bot, script, or otherwise;
        <br />
        (6) you will not use the Site for any illegal or unauthorized purpose;
        <br />
        (7) your use of the Site will not violate any applicable law or regulation.
        <p />
        <br /> <p>
          If you provide any information that is untrue, inaccurate, not current, or
          incomplete, we have the right to suspend or terminate your account and
          refuse any and all current or future use of the Site (or any portion
          thereof).
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            USER REGISTRATION
            <br />
          </strong>
        </h2>
        You may be required to register with the Site. You agree to keep your password
        confidential and will be responsible for all use of your account and password.
        You are not permitted to share your username and/or password with anyone. If
        we learn you have shared your username and/or password with another person, we
        reserve the right to immediately terminate your access to the Site, the
        Content or any other related communication. It is your responsibility to
        protect your own password from disclosure to others. We cannot and will not be
        liable for any loss or damage arising from your failure to protect your
        password or account information. We reserve the right to remove, reclaim, or
        change a username you select if we determine, in our sole discretion, that
        such username is inappropriate, obscene, or otherwise objectionable.
        <p />
        <br /> <p>
          You agree to notify us immediately of any unauthorized use of your password
          or account or any other breach of security, and to ensure that you exit from
          your account at the end of each session. By using the Site and/or the
          Content, you agree to enter true and accurate information as part of the
          registration, purchase process and otherwise. If you enter a false
          information, we have the right to immediately deactivate your account. We
          will use our best efforts to keep your password(s) private and will not
          otherwise share your password(s) without your consent, except as necessary
          when the law requires it or in the good faith belief that such action is
          necessary, particularly when disclosure is necessary to identify, contact or
          bring legal action against someone who may be causing injury to others or
          interfering with our rights or property.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            PROHIBITED ACTIVITIES
            <br />
          </strong>
        </h2>
        You may not access or use the Site for any purpose other than that for which
        we make the Site available. The Site may not be used in connection with any
        commercial endeavors except those that are specifically endorsed or approved
        by us.
        <p />
        <br /> <p>As a user of the Site, you agree not to:</p>
        <ol style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li>
            Systematically retrieve data or other content from the Site to create or
            compile, directly or indirectly, a collection, compilation, database, or
            directory without written permission from us.
          </li>
          <li>
            Engage in improper and/or unauthorized use of the Site and the Content.
            Improper and unauthorized use includes but is not limited to modifying,
            copying, reproducing, republishing, uploading, posting, transmitting,
            translating, selling, creating derivative works, exploiting, or
            distributing in any manner or medium (including by email or other
            electronic means) any Content or any other information accessed or
            purchased through our Products, Services, or any other communications
            provided by us for your own personal use, business/commercial use or in
            any way that earns you money.
          </li>
          <li>
            Duplicate, share, trade, sell, or otherwise distribute any part of the
            Site or the Content to any other person, for their personal use,
            business/commercial use or in any way that earns them money, whether it
            was known to you or not at the time that you shared the information that
            their intention was to use the Content for their own personal use or
            business/commercial use. This means you cannot share or sell any part of
            the Site and/or the Content to someone else so they can copy and/or use
            them for their own personal use, business/commercial use or in any way
            that earns them money. You are the only one granted a limited license to
            use the Site and/or the Content.
          </li>
          <li>
            Violate in any other way our intellectual property rights, including
            copyright and trademark rights.
          </li>
          <li>
            Circumvent, disable, or otherwise interfere with security-related features
            of the Site, including features that prevent or restrict the use or
            copying of any Content or enforce limitations on the use of the Site
            and/or the Content contained therein.
          </li>
          <li>
            Trick, defraud, or mislead us and other users, especially in any attempt
            to learn sensitive account information such as user passwords.
          </li>
          <li>
            Make improper use of our support services or submit false reports of abuse
            or misconduct.
          </li>
          <li>
            Engage in any automated use of the system, such as using scripts to send
            comments or messages, or using any data mining, robots, or similar data
            gathering and extraction tools.
          </li>
          <li>
            Interfere with, disrupt, or create an undue burden on the Site or the
            networks or services connected to the Site.
          </li>
          <li>Sell or otherwise transfer your profile.</li>
          <li>
            Use any information obtained from the Site in order to harass, abuse, or
            harm another person.
          </li>
          <li>
            Use the Site as part of any effort to compete with us or otherwise use the
            Site and/or the Content for any revenue-generating endeavor or commercial
            enterprise.
          </li>
          <li>
            Decipher, decompile, disassemble, or reverse engineer any of the software
            comprising or in any way making up a part of the Site.
          </li>
          <li>
            Attempt to bypass any measures of the Site designed to prevent or restrict
            access to the Site, or any portion of the Site.
          </li>
          <li>
            Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to you.
          </li>
          <li>
            Copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.
          </li>
          <li>
            Upload or transmit (or attempt to upload or to transmit) viruses, Trojan
            horses, or other material, including excessive use of capital letters and
            spamming (continuous posting of repetitive text), that interferes with any
            party’s uninterrupted use and enjoyment of the Site or modifies, impairs,
            disrupts, alters, or interferes with the use, features, functions,
            operation, or maintenance of the Site and/or harm the Site and the Company
            in any other way.
          </li>
          <li>
            Use the Site in a manner inconsistent with any applicable laws or
            regulations or in a manner that has not been authorized by us through our
            prior written consent.
          </li>
        </ol>
        <br /> <p>
          You understand and agree that engaging in the prohibited use or the improper
          and/or unauthorized use of the Site and the Content as set forth in these
          Terms of Service is considered theft and stealing and we retain the right to
          prosecute theft to the full extent of the law.
          <br />
          You agree and understand that prohibited use, improper and/or unauthorized
          use may give rise to a civil claim for damages and/or be a criminal offense.
        </p>
        <br /> <p>
          Any request for written permission to use the Content, in whole or in part,
          or any other intellectual property or property belonging to us (“Content”),
          should be made BEFORE you wish to use it by completing the “Contact Us” form
          on the Site, or by sending an e-mail to {import.meta.env.VITE_MY_WORK_EMAIL}
        </p>
        <br /> <p>
          We very clearly state that you may not use the Site and/or the Content, in
          whole or in part, in any way that is contrary to these Terms of Service
          unless we have given you specific written permission to do so. If you are
          granted permission by us, you agree to use the specific Content that we
          allow and ONLY in the ways for which we have given you our written
          permission.
          <br /><br />
          If you choose to use the content in ways that we do not specifically give
          you written permission, you agree now that you will be treated as if you had
          copied, duplicated and/or stolen such Content from us, and you consent to
          immediately stop using such Content and to take whatever actions as we may
          request and by the methods and in the time frame that we prescribe to
          protect our intellectual property and ownership rights of the Site and the
          Content.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            USER GENERATED CONTRIBUTIONS
            <br />
          </strong>
        </h2>
        The Site may invite you to chat, contribute to, or participate in blogs,
        message boards, online forums, and other functionality, and may provide you
        with the opportunity to create, submit, post, display, transmit, perform,
        publish, distribute, or broadcast content and materials to us or on the Site,
        including but not limited to text, writings, video, audio, photographs,
        graphics, comments, suggestions, or personal information or other material
        (collectively, “Contributions”).
        <p />
        <br /> <p>
          Contributions may be viewable by other users of the Site and through
          third-party websites. As such, any Contributions you transmit may be treated
          as non-confidential and non-proprietary. When you create or make available
          any Contributions, you thereby represent and warrant that:
        </p>
        <ol style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li>
            The creation, distribution, transmission, public display, or performance,
            and the accessing, downloading, or copying of your Contributions do not
            and will not infringe the proprietary rights, including but not limited to
            the copyright, patent, trademark, trade secret, or moral rights of any
            third party.
          </li>
          <li>
            You are the creator and owner of or have the necessary licenses, rights,
            consents, releases, and permissions to use and to authorize us, the Site,
            and other users of the Site to use your Contributions in any manner
            contemplated by the Site and these Terms of Service.
          </li>
          <li>
            You have the written consent, release, and/or permission of each and every
            identifiable individual person in your Contributions to use the name or
            likeness of each and every such identifiable individual person to enable
            inclusion and use of your Contributions in any manner contemplated by the
            Site and these Terms of Service.
          </li>
          <li>Your Contributions are not false, inaccurate, or misleading.</li>
          <li>
            Your Contributions are not unsolicited or unauthorized advertising,
            promotional materials, pyramid schemes, chain letters, spam, mass
            mailings, or other forms of solicitation.
          </li>
          <li>
            Your Contributions are not obscene, filthy, violent, harassing,
            slanderous, or otherwise objectionable (as determined by us).
          </li>
          <li>
            Your Contributions do not ridicule, mock, disparage, intimidate, or abuse
            anyone.
          </li>
          <li>
            Your Contributions do not advocate the violent overthrow of any government
            or incite, encourage, or threaten physical harm against another.
          </li>
          <li>
            Your Contributions do not violate any applicable law, regulation, or rule.
          </li>
          <li>
            Your Contributions do not violate the privacy or publicity rights of any
            third party.
          </li>
          <li>
            Your Contributions do not contain any material that solicits personal
            information from anyone under the age of 18 or exploits people under the
            age of 18 in a sexual or violent manner.
          </li>
          <li>
            Your Contributions do not violate any federal or state law concerning
            child pornography, or otherwise intended to protect the health or
            well-being of minors;
          </li>
          <li>
            Your Contributions do not include any offensive comments that are
            connected to race, national origin, gender, sexual preference, or physical
            handicap.
          </li>
          <li>
            Your Contributions do not otherwise violate, or link to material that
            violates, any provision of these Terms of Service, or any applicable law
            or regulation.
          </li>
        </ol>
        <br /> <p>
          Any use of the Site in violation of the foregoing violates these Terms of
          Service and may result in, among other things, termination or suspension of
          your rights to use the Site.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            CONTRIBUTION LICENSE
            <br />
          </strong>
        </h2>
        By posting your Contributions to any part of the Site or making Contributions
        accessible to the Site by linking your account from the Site to any of your
        social networking accounts, you automatically grant, and you represent and
        warrant that you have the right to grant, to us, and anyone authorized by us,
        &nbsp;an unrestricted, unlimited, irrevocable, perpetual, non-exclusive,
        transferable, royalty-free, fully-paid, worldwide right, and license to host,
        use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle,
        archive, store, cache, publicly perform, publicly display, reformat,
        translate, transmit, excerpt (in whole or in part), and distribute such
        Contributions (including, without limitation, your image and voice) for any
        purpose, commercial, advertising, or otherwise, and to prepare derivative
        works of, or incorporate into other works, such Contributions, and grant and
        authorize sublicenses of the foregoing. The use and distribution may occur in
        any media formats and through any media channels.
        <p />
        <br /> <p>
          This license will apply to any form, media, or technology now known or
          hereafter developed, and includes our use of your name, company name, as
          applicable, and any of the trademarks, service marks, trade names, logos,
          and personal and commercial images you provide. You waive all moral rights
          in your Contributions, and you warrant that moral rights have not otherwise
          been asserted in your Contributions.
        </p>
        <br /> <p>
          We do not assert any ownership over your Contributions. You retain full
          ownership of all of your Contributions and any intellectual property rights
          or other proprietary rights associated with your Contributions. We are not
          liable for any statements or representations in your Contributions provided
          by you in any area on the Site.
        </p>
        <br /> <p>
          You are solely responsible for your Contributions to the Site and you
          expressly agree to exonerate us from any and all responsibility and to
          refrain from any legal action against us regarding your Contributions.&nbsp;
        </p>
        <br /> <p>
          We have the right, in our sole and absolute discretion, (1) to edit, redact,
          or otherwise change any Contributions; (2) to re-categorize any
          Contributions to place them in more appropriate locations on the Site; and
          (3) to pre-screen or delete any Contributions at any time and for any
          reason, without notice. We have no obligation to monitor your Contributions.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            SUBMISSIONS
            <br />
          </strong>
        </h2>
        You acknowledge and agree that any questions, comments, suggestions, ideas,
        feedback, or other information regarding the Site (“Submissions”) provided by
        you to us are non-confidential and shall become our sole property. We shall
        own exclusive rights, including all intellectual property rights, and shall be
        entitled to the unrestricted use and dissemination of these Submissions for
        any lawful purpose, commercial or otherwise, without acknowledgment or
        compensation to you.
        <p />
        <br /> <p>
          You hereby waive all moral rights to any such Submissions, and you hereby
          warrant that any such Submissions are original with you or that you have the
          right to submit such Submissions. You agree there shall be no recourse
          against us for any alleged or actual infringement or misappropriation of any
          proprietary right in your Submissions.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            THIRD-PARTY WEBSITES AND CONTENT
            <br />
          </strong>
        </h2>
        The Site may contain (or you may be sent via the Site) links to other websites
        (“Third-Party Websites”) as well as articles, photographs, text, graphics,
        pictures, designs, music, sound, video, information, applications, software,
        and other content or items belonging to or originating from third parties
        (“Third-Party Content”).
        <p />
        <br /> <p>
          Such Third-Party Websites and Third-Party Content are not investigated,
          monitored, or checked for accuracy, appropriateness, or completeness by us,
          and we are not responsible for any Third-Party Websites accessed through the
          Site or any Third-Party Content posted on, available through, or installed
          from the Site, including the content, accuracy, offensiveness, opinions,
          reliability, privacy practices, or other policies of or contained in the
          Third-Party Websites or the Third-Party Content.
        </p>
        <br /> <p>
          Inclusion of, linking to, or permitting the use or installation of any
          Third-Party Websites or any Third-Party Content does not imply approval or
          endorsement thereof by us. If you decide to leave the Site and access the
          Third-Party Websites or to use or install any Third-Party Content, you do so
          at your own risk, and you should be aware these Terms of Service no longer
          govern.
        </p>
        <br /> <p>
          You should review the applicable terms and policies, including privacy and
          data gathering practices, of any website to which you navigate from the Site
          or relating to any applications you use or install from the Site. Any
          purchases you make through Third-Party Websites will be through other
          websites and from other companies, and we take no responsibility whatsoever
          in relation to such purchases which are exclusively between you and the
          applicable third party.
        </p>
        <br /> <p>
          You agree and acknowledge that we do not endorse the products or services
          offered on Third-Party Websites and you shall hold us harmless from any harm
          caused by your purchase of such products or services. Additionally, you
          shall hold us harmless from any losses sustained by you or harm caused to
          you relating to or resulting in any way from any Third-Party Content or any
          contact with Third-Party Websites.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            SITE MANAGEMENT
            <br />
          </strong>
        </h2>
        We reserve the right, but not the obligation, to:
        <br />
        (1) monitor the Site for violations of these Terms of Service;
        <br />
        (2) take appropriate legal action against anyone who, in our sole discretion,
        violates the law or these Terms of Service, including without limitation,
        reporting such user to law enforcement authorities;
        <br />
        (3) in our sole discretion and without limitation, refuse, restrict access to,
        limit the availability of, or disable (to the extent technologically feasible)
        any of your Contributions or any portion thereof;
        <br />
        (4) in our sole discretion and without limitation, notice, or liability, to
        remove from the Site or otherwise disable all files and content that are
        excessive in size or are in any way burdensome to our systems;
        <br />
        (5) otherwise manage the Site in a manner designed to protect our rights and
        property and to facilitate the proper functioning of the Site.
        <p />
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            PRIVACY POLICY
            <br />
          </strong>
        </h2>
        We care about data privacy and security. Please review our full Privacy Policy
        posted on the Site. By using the Site, you agree to be bound by our Privacy
        Policy.
        <br />
        To use the Site and/or the Content, we may seek personal data or information
        including your name, email address, phone number, street address, billing
        information, birthday, preferences, interests, assignments, or other
        personally-identifiable information (“Confidential Information”), or you may
        offer or provide a comment, photo, image, video or any other submission to us
        when using or participating on the Site and/or the Content (“Other
        Information”). By providing such Confidential Information or Other Information
        to us, you grant us permission to use and store such information in accordance
        with our Privacy Policy. We, in turn, will use our best efforts to keep your
        Confidential Information safe, secure and confidential in accordance with
        these Terms of Service and our full Privacy Policy which may be found on the
        Site.
        <p />
        <br /> <p>
          However, due to the nature of the Internet, we cannot completely ensure or
          warrant the security of your Confidential Information or any other data or
          information transmitted to us or through our services; therefore, submitting
          Confidential Information, data or other information is done at your own
          risk.&nbsp; We have reasonable security measures in place to prevent the
          loss, misuse, and alteration of the information that is obtained from you,
          but we make no assurances about our ability to prevent any such loss,
          misuse, to you or to any third party arising out of any such loss, misuse,
          or alteration.
        </p>
        <br /> <p>
          If you believe that any of your Confidential Information is incorrect or
          incomplete, please contact us as soon as possible. We will promptly correct
          any Confidential Information found to be incorrect.
        </p>
        <br /> <p>
          <strong>How we use your Confidential Information.</strong> We request and
          require various personal data and/or Confidential Information to understand
          your needs and provide you with better services. In addition, we may use
          such data and Confidential Information for the following reasons: (1) for
          internal record keeping, (2) to improve the Site and/or the Content, (3) to
          periodically send promotions about new Products, Services or other special
          offers from which you may unsubscribe at any time, (4) for aggregate,
          non-identifiable data for research purposes, (5) to customize the respective
          Products or Services you purchase or use according to your interests and/or
          (6) for support or communication related to your requests.
        </p>
        <br /> <p>
          <strong>Storage.</strong>&nbsp; All data and Confidential Information is
          stored through a data management system. This data and Confidential
          Information can only be accessed by those who help manage that information
          in order to deliver email or otherwise contact those who would like to
          receive our correspondence.&nbsp; You agree and acknowledge that we,
          including but not limited to our team, staff and affiliates, and those who
          manage the data management system may have access to your Confidential
          Information.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            TERM AND TERMINATION
            <br />
          </strong>
        </h2>
        These Terms of Service shall remain in full force and effect while you use the
        Site and in the future, even after termination by you or us. You have the
        right to terminate your use of or participation in our Products or Services at
        any time by sending an e-mail to {import.meta.env.VITE_MY_WORK_EMAIL}
        <p />
        <br /> <p>
          WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF SERVICE, WE RESERVE
          THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY
          ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO
          ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR
          BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS
          OF SERVICE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE
          OR PARTICIPATION IN THE SITE OR DELETE YOUR ACCOUNT AND/OR ANY CONTENT OR
          INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE
          DISCRETION.
        </p>
        <br /> <p>
          If we terminate or suspend your account for any reason, you are prohibited
          from registering and creating a new account under your name, a fake or
          borrowed name, or the name of any third party, even if you may be acting on
          behalf of the third party.
        </p>
        <br /> <p>
          In addition to terminating or suspending your account, we reserve the right
          to take appropriate legal action, including without limitation pursuing
          civil, criminal, and injunctive redress.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            MODIFICATIONS AND INTERRUPTIONS <br />
          </strong>
        </h2>
        We reserve the right to change, modify, or remove the contents of the Site at
        any time or for any reason at our sole discretion without notice. However, we
        have no obligation to update any information on our Site. We also reserve the
        right to modify or discontinue all or part of the Site without notice at any
        time.
        <br />
        We will not be liable to you or any third party for any modification, price
        change, suspension, or discontinuance of the Site.
        <p />
        <br /> <p>
          We cannot guarantee the Site will be available at all times. We may
          experience hardware, software, or other problems or need to perform
          maintenance related to the Site, resulting in interruptions, delays, or
          errors.
        </p>
        <br /> <p>
          We reserve the right to change, revise, update, suspend, discontinue, or
          otherwise modify the Site at any time or for any reason without notice to
          you. You agree that we have no liability whatsoever for any loss, damage, or
          inconvenience caused by your inability to access or use the Site during any
          downtime or discontinuance of the Site.
        </p>
        <br /> <p>
          Nothing in these Terms of Service will be construed to obligate us to
          maintain and support the Site or to supply any corrections, updates, or
          releases in connection therewith.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            GOVERNING LAW <br />
          </strong>
        </h2>
        These Terms of Service and your use of the Site are governed by the laws of
        the country of Ukraine, regardless of the conflict of laws principles.
        <p />
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            DISPUTE RESOLUTION
            <br />
          </strong>
        </h2>
        It is hoped that should we ever have any differences, we could be able to work
        them out amiably through e-mail correspondence. However, should we be unable
        to seek resolution within a reasonable time, you agree now that the only
        method of legal dispute resolution that will be used is binding arbitration
        before a single arbitrator, selected jointly, in accordance with the Ukrainian
        Arbitration Association Rules. Prior to seeking arbitration, you must send an
        e-mail to us at {import.meta.env.VITE_MY_WORK_EMAIL}
        <p />
        <br /> <p>
          and include all of your reasons for dissatisfaction with your Product,
          Service. You understand and agree now that the only remedy that can be
          awarded to you through arbitration is full refund of your Payment made to
          date. No other actions or financial awards of consequential damages, or any
          other type of damages, may be granted to you. We both agree now that the
          decision of the arbitrator is final and binding, and may be entered as a
          judgment into any court having the appropriate jurisdiction.
        </p>
        <br /> <p>
          You also agree that should arbitration take place, it will be held in Kyiv,
          Ukraine, and the prevailing party shall be entitled to all reasonable
          attorneys’ fees and all costs necessary to enforce the decision of the
          arbitrator.
        </p>
        <br /> <p>
          In the event of a dispute between us, you agree to not engage in any conduct
          or communications, including on social media, designed to disparage us, our
          Company, or any of our Products and/or Services. Where requested by law or
          arbitration, of course, you are not prohibited from sharing your thoughts
          and opinions as a part of the legal process.
        </p>
        <br /> <p>
          If any terms of these Terms of Service are construed to be invalid or
          unenforceable for any reason, it shall not affect the validity or
          enforceability of any other term which shall be given full force and effect.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            ERRORS AND OMISSIONS
            <br />
          </strong>
        </h2>
        We make no warranty or guarantee as to the accuracy, timeliness, performance,
        completeness or suitability of the information on the Site including any of
        the Content. Every effort has been made to present you with the most accurate,
        up-to-date information, but because the nature of scientific research is
        constantly evolving, we cannot be held responsible or accountable for the
        accuracy of the Content. You acknowledge that such information may contain
        inaccuracies or errors and we are not liable for any such inaccuracies or
        errors to the fullest extent permitted by law.
        <p />
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            DISCLAIMER
            <br />
          </strong>
        </h2>
        THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR
        USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST
        EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN
        CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION,
        THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
        AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE
        ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES
        LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY
        (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL
        INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR
        ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR
        SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL
        INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION
        TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH
        MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY
        ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF
        ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED,
        OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE,
        GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR
        OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY
        WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND
        WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY
        TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.
        <p />
        <br /> <p>
          THE CONTENT IS FOR INFORMATIONAL AND EDUCATIONAL PURPOSES ONLY AND IS NOT TO
          BE PERCEIVED AS OR RELIED UPON IN ANY WAY AS MEDICAL ADVICE, HEALTH ADVICE,
          PSYCHOLOGICAL, LEGAL AND/OR FINANCIAL ADVICE. WE ARE NOT PROVIDING HEALTH
          CARE, MEDICAL OR NUTRITION SERVICES OR ATTEMPTING TO DIAGNOSE, TREAT,
          PREVENT AND/OR CURE IN ANY MANNER WHATSOEVER ANY MENTAL, EMOTIONAL, PHYSICAL
          ISSUE, DISEASE OR CONDITION. TO THE FULLEST EXTENT PERMITTED BY LAW, WE
          EXPRESSLY EXCLUDE ANY LIABILITY FOR ANY DIRECT, INDIRECT OR CONSEQUENTIAL
          LOSS OR DAMAGE INCURRED BY YOU OR OTHERS IN CONNECTION WITH THE SITE AND/OR
          THE CONTENT INCLUDING WITHOUT LIMITATION ANY LIABILITY FOR ANY ACCIDENTS,
          INJURIES, HARM, LOSS, DAMAGE, LOST PROFITS, PHYSICAL, MENTAL, EMOTIONAL,
          SPIRITUAL INJURY, HARM, LOSS OF INCOME, BUSINESS AND ANY OTHER LOSS OR
          DAMAGE OF ANY KIND, HOWEVER AND WHETHER CAUSED BY NEGLIGENCE, BREACH OF
          CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE.
        </p>
        <br /> <p>
          AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY
          ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE
          APPROPRIATE.
        </p>
        <br /> <p>
          WE TRY TO ENSURE THE AVAILABILITY AND UNINTERRUPTED ACCESS TO THE SITE AND
          THE CONTENT. HOWEVER, WE CANNOT GUARANTEE THAT YOUR ACCESS WILL NOT BE
          SUSPENDED OR RESTRICTED FROM TIME TO TIME, INCLUDING TO ALLOW FOR
          MAINTENANCE OR UPDATES, ALTHOUGH, WE WILL TRY TO LIMIT THE FREQUENCY AND
          DURATION OF SUSPENCION OR RESTRICTION. TO THE FULLEST EXTENT PERMITTED BY
          LAW, WE WILL NOT BE LIABLE TO YOU FOR ANY DAMAGES OR REFUNDS, SHOULD THE
          SITE AND/OR THE CONTENT, IN WHOLE OR IN PART, BECOME UNAVAILABLE OR ACCESS
          TO THEM BECOMES SLOW DUE TO ANY REASON INCLUDING BUT NOT LIMITED TO
          UPGRADES, INTERNET TRAFFIC VOLUME, SERVERS’ OVERLOADS, GENERAL NETWORK
          FAILURES, OR ANY OTHER CAUSE.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            LIMITATIONS OF LIABILITY
            <br />
          </strong>
        </h2>
        IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, AFFILIATES OR AGENTS BE
        LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,
        EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED
        TO ANY HARM, DISEASE, LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR ANY OTHER
        DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES.
        <p />
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            INDEMNIFICATION
            <br />
          </strong>
        </h2>
        You agree to defend, indemnify, and hold us harmless, including our
        subsidiaries, affiliates, and all of our respective officers, agents,
        partners, and employees, from and against any loss, damage, liability, claim,
        or demand, including reasonable attorneys’ fees and expenses, made by any
        third party due to or arising out of: (1) your Contributions; (2) use of the
        Site; (3) breach of these Terms of Service; (4) any breach of your
        representations and warranties set forth in these Terms of Service; (5) your
        violation of the rights of a third party, including but not limited to
        intellectual property rights; or (6) any overt harmful act toward any other
        user of the Site with whom you connected via the Site.
        <p />
        <br /> <p>
          Notwithstanding the foregoing, we reserve the right, at your expense, to
          assume the exclusive defense and control of any matter for which you are
          required to indemnify us, and you agree to cooperate, at your expense, with
          our defense of such claims. We will use reasonable efforts to notify you of
          any such claim, action, or proceeding which is subject to this
          indemnification upon becoming aware of it.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            USER DATA
            <br />
          </strong>
        </h2>
        We will maintain certain data that you transmit to the Site for the purpose of
        managing the Site, as well as data relating to your use of the Site. Although
        we perform regular routine backups of data, you are solely responsible for all
        data that you transmit or that relates to any activity you have undertaken
        using the Site.
        <p />
        <br /> <p>
          You agree that we shall have no liability to you for any loss or corruption
          of any such data, and you hereby waive any right of action against us
          arising from any such loss or corruption of such data.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
            <br />
          </strong>
        </h2>
        Visiting the Site, sending us emails, purchasing our Products, Services, and
        completing online forms constitute electronic communications. You consent to
        receive electronic communications, and you agree that all agreements, notices,
        disclosures, and other communications we provide to you electronically, via
        email and on the Site, satisfy any legal requirement that such communication
        be in writing.
        <p />
        <br /> <p>
          YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND
          OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS
          OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE.
        </p>
        <br /> <p>
          You hereby waive any rights or requirements under any statutes, regulations,
          rules, ordinances, or other laws in any jurisdiction which require an
          original signature or delivery or retention of non-electronic records, or to
          payments or the granting of credits by any means other than electronic
          means.
        </p>
        <br /> <p>
          All information obtained during your purchase or transaction for our
          Products and/or Services and all of the information that you give as part of
          the transaction, such as your name, address, method of payment, credit card
          number, and billing information, may be collected by both us and our payment
          processing company. Per our Privacy Policy, please make sure that you review
          the privacy policy of our payment processor.
        </p>
        <br /> <p>
          At the moment we use www.wayforpay.com as our main payment processor
          platform. That means that if you are making a purchase using credit card
          credentials other than ukrainian then your bank may block the payment as
          suspicious because the currency is UAH and not USD. So, you will have to
          contact your bank’s support and ask them to proceed with the payment. Some
          additional international currency exchange rates may apply.
        </p>
        <br /> <p>
          You agree to only purchase goods or services for yourself or for another
          person for whom you are legally permitted to do so or for whom you have
          obtained the express consent to provide their name, address, method of
          payment, credit card number, and billing information.
        </p>
        <br /> <p>
          You agree to be financially responsible for all purchases made by you or
          someone acting on your behalf. You agree to use our Products, Services for
          legitimate, non-commercial purposes only and not for speculative, false,
          fraudulent, or illegal purposes.
        </p>
        <br /> <p>
          If you make a purchase from one of our affiliates, or any other individual
          or company through a link provided on or through our Products or Services
          (“Merchant”), all information obtained during your purchase or transaction
          and all of the information that you give as part of the transaction, such as
          your credit card number and contact information, may be collected by the
          merchant and their payment processing company as well. Your participation,
          correspondence or business dealings with any affiliate, individual or
          company on or through our Products or Services, and all purchase terms,
          conditions, representations or warranties associated with payment, refunds,
          and/or delivery related to your purchase, are solely between you and the
          Merchant. You agree that we shall not be responsible or liable for any loss,
          damage, refunds, or other matters of any sort that incurred as the result of
          such dealings with a Merchant.
        </p>
        <br /> <p>
          Payment processing companies and Merchants may have privacy and data
          collection practices that are different from ours. We have no responsibility
          or liability for these independent policies of the payment processing
          companies and Merchants. In addition, when you make certain purchases
          through our Products or Services you may be subject to the additional Terms
          of Service of a payment processing company, Merchant or us that specifically
          apply to your purchase. For more information regarding a Merchant and its
          Terms of Service that may apply, visit that merchant’s Website and click on
          its information links or contact the Merchant directly.
        </p>
        <br /> <p>
          You release us, our affiliates, our payment processing company, and
          Merchants from any damages that you incur, and agree not to assert any
          claims against us or them, arising from your purchase through or use of our
          Website or its Content.
        </p>
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            REFUND POLICY
            <br />
          </strong>
        </h2>
        Your satisfaction with our Products, Services is important to us and we truly
        believe that our products can help you improve your life. So, to make this
        decision easier for you, unless otherwise provided by law or in the specific
        parts of the Site, we offer a 30 days money back guarantee for any of our
        Content, Products, Services, no questions asked.
        <p />
        <br /><h2 className="text-[#2a7a2a]">
          <strong>
            CONTACT US
            <br />
          </strong>
        </h2>
        If you have any questions about the Site and/or the Content, you may send an
        e-mail to {import.meta.env.VITE_MY_WORK_EMAIL} and we will do our best to reply to your
        question or concern promptly.
        <p />
      </>

    </div>
  );
}
